import { Point as FabricPoint, util } from 'fabric';

import { Coords } from 'editor/src/store/design/types';

import { Point, Segment } from 'editor/src/util/2d/types';
import { convFn } from 'editor/src/util/convFn';

import { CanvasRotation } from '../types';

export type GuideAxis = 'horizontal' | 'vertical';
export interface RulerGuide {
  id: number;
  axis: GuideAxis;
  position: number;
}

export function documentGuideAxis(screenAxis: GuideAxis, angleDeg: number): GuideAxis {
  const quarterTurn = Math.abs(Math.round(angleDeg / 90)) % 2 === 1;
  if (!quarterTurn) {
    return screenAxis;
  }
  return screenAxis === 'horizontal' ? 'vertical' : 'horizontal';
}

export function guideSegment(
  guide: Pick<RulerGuide, 'axis' | 'position'>,
  coords: Coords,
  width: number,
  height: number,
  mm2px: convFn,
  rotation: CanvasRotation,
): Segment {
  const x = coords.left + (guide.axis === 'vertical' ? mm2px(guide.position) : 0);
  const y = coords.top + (guide.axis === 'horizontal' ? mm2px(guide.position) : 0);
  const from = new FabricPoint(x, y);
  const to = new FabricPoint(
    guide.axis === 'horizontal' ? coords.left + mm2px(width) : x,
    guide.axis === 'vertical' ? coords.top + mm2px(height) : y,
  );
  return [
    util.rotatePoint(from, rotation.canvasCenter, rotation.angleRad),
    util.rotatePoint(to, rotation.canvasCenter, rotation.angleRad),
  ];
}

export function guidePosition(
  axis: GuideAxis,
  scenePoint: Point,
  coords: Coords,
  px2mm: convFn,
  rotation: CanvasRotation,
) {
  const point = util.rotatePoint(new FabricPoint(scenePoint), rotation.canvasCenter, -rotation.angleRad);
  return px2mm(axis === 'vertical' ? point.x - coords.left : point.y - coords.top);
}
